import { RouteObject } from "react-router-dom";
import { lazy, Suspense } from "react";
import HomePage from "../pages/home/page";
import ArticlesPage from "../pages/articles/page";
import ArticleDetailPage from "../pages/article/page";
import CategoriesPage from "../pages/categories/page";
import AboutPage from "../pages/about/page";
import GetStartedPage from "../pages/get-started/page";
import PricingPage from "../pages/pricing/page";
import FeaturesPage from "../pages/features/page";
import BuilderPage from "../pages/builder/page";
import PluginsPage from "../pages/plugins/page";
import DashboardPage from "../pages/dashboard/page";
import FAQPage from "../pages/faq/page";
import NotFound from "../pages/NotFound";
import VoiceTranslatorPage from "../pages/voice-translator/page";
import AINoteTakerPage from "../pages/ai-note-taker/page";

const TemplatesPage = lazy(() => import("../pages/templates/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/articles",
    element: <ArticlesPage />,
  },
  {
    path: "/article/:id",
    element: <ArticleDetailPage />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/features",
    element: <FeaturesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/get-started",
    element: <GetStartedPage />,
  },
  {
    path: "/builder",
    element: <BuilderPage />,
  },
  {
    path: "/plugins",
    element: <PluginsPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/voice-translator",
    element: <VoiceTranslatorPage />,
  },
  {
    path: "/ai-note-taker",
    element: <AINoteTakerPage />,
  },
  {
    path: "/templates",
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-4 border-teal-500 border-t-transparent rounded-full animate-spin" /></div>}>
        <TemplatesPage />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;